import { FC, useMemo } from 'react';
import Select from '../select';
import { FormProps } from '../helpers';
import Text from '@/components/text';
import { Stack } from '@mui/material';
import Chip from '@/components/chip';
import { ProxyConnectorAuthTypeOptions } from '@/lib/models/connector';
import { cloneDeep } from 'lodash';

interface Props extends FormProps {
  value: string;
  onChange: (value: string) => void;
}

const ProxyAuthTypeSelect: FC<Props> = (props) => {
  const niceOpts = useMemo(() => {
    return cloneDeep(ProxyConnectorAuthTypeOptions).map((opt) => {
      if (opt.meta?.recommended) {
        opt.label = (
          <Stack direction="row" gap={0.5} alignItems="center" justifyContent="space-between">
            <Text>{opt.label}</Text>
            <Chip label="Recommended" size="small" />
          </Stack>
        );
      }

      return opt;
    });
  }, []);

  return <Select {...props} options={niceOpts} />;
};

export default ProxyAuthTypeSelect;
